// removed by extract-text-webpack-plugin
module.exports = {"avatarHeader":"avatarHeader__1VI9l41GJ4wc","strong":"strong__2D-qHJegxLfU","buttonIcon":"buttonIcon__195hl5UDuqDb","button":"button__14cMly_rHerq"};